import { groq } from "next-sanity";
import { handleClientError } from "../../errors";
import { getClient } from "../sanity";

export type News = {
  imageUrl: string;
  title: string;
  description: string;
  source: string;
  link: string;
  publishedAt: string;
};

export const getNewsArticles = async (): Promise<News[]> => {
  const query = groq`
    *[_type == "news"] {
      title,
      description,
      source,
      link,
      publishedAt,
      'imageUrl': image.asset->url,
    } | order(publishedAt desc)
  `;

  try {
    const news = await getClient().fetch(query);
    return news;
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    handleClientError(`Failed to fetch news articles: ${errorMessage}`);
    return [];
  }
};
